<script setup>

const props = defineProps({
    title: {
        type: String,
        required: true
    }
})

</script>

<template>
    <section class="section m-hero m-articles-hero">
        <div class="m-hero__title">
            <h1 class="c-page-title">
                {{ title }}
            </h1>
        </div>
    </section>
</template>